import type { RefItem } from '../api/types';

export function RefSelect({
  label,
  value,
  onChange,
  options,
  placeholder = '—',
}: {
  label: string;
  value: string;
  onChange: (v: string) => void;
  options?: RefItem[];
  placeholder?: string;
}) {
  return (
    <div className="field">
      <label>{label}</label>
      <select value={value} onChange={(e) => onChange(e.target.value)}>
        <option value="">{placeholder}</option>
        {options?.map((o) => (
          <option key={o.id} value={o.id}>
            {o.name}
          </option>
        ))}
      </select>
    </div>
  );
}
